import {downloadOrder as downloadOrderRequest} from '../api';
import {EnqueueSnackbar} from '../components/Snackbar';
import {
  DOWNLOAD_TOO_WAIT,
  MISSING_DERIVATES_MESSAGE,
  TOKEN_EXPIRED,
  ERROR_DOWNLOAD,
  API_BASE_URL,
} from '../constants';

function downloadOrder(
  token: string,
  enqueueSnackbar: EnqueueSnackbar,
  urlList: Record<string, string>[],
  singleFile: boolean,
  resultHandler: (url: string) => void,
  setPercentage?: (value: number) => void,
  derivate?: string,
) {
  if (!setPercentage) {
    setPercentage = _number => {};
  } else {
    setPercentage(20);
  }
  const derivateString = derivate ? `&derivate=${derivate}` : '';
  downloadOrderRequest(singleFile, derivateString, urlList, token)
    .then(res => {
      const id = res.data.id;

      if (res.status === 206) {
        const noDvNum = res.data.noDerivateFiles.length;
        const noDvFileName = '"' + res.data.noDvFileName + '"';
        enqueueSnackbar(
          MISSING_DERIVATES_MESSAGE.replace('{1}', String(noDvNum)).replace(
            '{2}',
            noDvFileName,
          ),
          {variant: 'warning', autoHideDuration: 15000},
        );
      }
      resultHandler(`${API_BASE_URL}/download/${id}`);
      setPercentage(0);
    })
    .catch(err => {
      switch (err?.response?.status) {
        case 401:
          enqueueSnackbar(TOKEN_EXPIRED, {variant: 'error'});
          break;
        case 429:
          enqueueSnackbar(DOWNLOAD_TOO_WAIT, {variant: 'warning'});
          break;
        default:
          enqueueSnackbar(ERROR_DOWNLOAD, {variant: 'error'});
      }
      setPercentage(0);
    });
}
export function downloadFile(
  token: string,
  enqueueSnackbar: EnqueueSnackbar,
  url: string,
) {
  const urlList: Record<string, string>[] = [];
  const urlsParams = createURLParamFromPath(url);
  urlList.push(urlsParams);
  downloadOrder(token, enqueueSnackbar, urlList, true, download);
}

export function download(url: string, _name?: string) {
  // const concatenator = url.indexOf('?') === -1 ? '?' : '&';

  const endURL =
    url.startsWith('http') || url.startsWith(API_BASE_URL)
      ? url
      : `${API_BASE_URL}${url}`;

  window.location.assign(endURL);
}

function createURLParamFromPath(path: string): Record<string, string> {
  const urlString = path.replace('/images/', '').split('?');
  const urlsParams: Record<string, string> = {
    path: urlString[0],
  };

  if (urlString[1]) {
    urlString[1].split('&').forEach(param => {
      const [key, value] = param.split('=');
      if (key && value) {
        urlsParams[key] = value;
      }
    });
  }

  return urlsParams;
}

export function downloadZip(
  token: string,
  derivate: string,
  enqueueSnackbar: EnqueueSnackbar,
  setPercentage?: (value: number) => void,
  resultHandler?: (url: string) => void,
) {
  const resultHandlerFunction = resultHandler ?? download;
  const basket = JSON.parse(localStorage.getItem('basket') ?? '[]');
  const urls = basket.map((item: {download: string}) => item.download);
  const urlList: Record<string, string>[] = [];
  urls.forEach((url: string) => {
    urlList.push(createURLParamFromPath(url));
  });
  downloadOrder(
    token,
    enqueueSnackbar,
    urlList,
    false,
    resultHandlerFunction,
    setPercentage,
    derivate,
  );
}

export function getBasketLink(
  token: string,
  derivate: string,
  enqueueSnackbar: EnqueueSnackbar,
  setBasketLink: (url: string) => void,
) {
  downloadZip(token, derivate, enqueueSnackbar, undefined, setBasketLink);
}

export function formatBytes(bytes: number, hasDecimals: boolean) {
  if (bytes === 0) return '0 Bytes';

  let decimals = 0;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));

  if (!hasDecimals) {
    if (sizes[i] === 'GB') decimals = 1;
  } else {
    decimals = 2;
  }

  const formattedNumber = (bytes / Math.pow(1024, i)).toFixed(decimals);

  return `${formattedNumber} ${sizes[i]}`;
}
